import React from "react"

function DefaultTitle({ merchantName }) {
  return (
    <p className="title-text">
      <b>{merchantName}</b> would like to:
    </p>
  )
}

export default DefaultTitle
